export const AddressAction = {
    GET_STATE_LIST: "get_state_list",
    GET_DISTRICT_LIST: "get_district_list",
    GET_SUB_DISTRICT_LIST: "get_sub_district_list",
    GET_VILLAGE_LIST: "get_village_list",
    SEARCH_VILLAGE_LIST: "search_village_list"
}